import React from 'react';

import PropTypes from 'prop-types';

import { Heading, Type } from '@nerdwallet/currency';

import style from './title.module.less';

const Title = ({ subcopy, title }) => (
  <div className={style.container}>
    <Heading component="h1" level={3}>
      {title}
    </Heading>
    {subcopy && <Type className={style.subcopy}>{subcopy}</Type>}
  </div>
);

Title.propTypes = {
  title: PropTypes.string.isRequired,
  subcopy: PropTypes.node,
};

Title.defaultProps = {
  subcopy: null,
};

export default Title;
